import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProcesoProductivo } from '../../_models/proceso-productivo';
import { ProcesoProductivoService } from '../../_services/proceso-productivo.service';
import { forkJoin } from 'rxjs';
import { ProcesoVariableIncidenciaService } from '../../_services/proceso-variable-incidencia.service';
import { ProcesoVariableIncidencia } from '../../_models/proceso-variable-incidencia';

@Component( {
  selector: 'app-proceso-productivo-detalle',
  templateUrl: 'proceso-productivo-detalle.component.html'
} )

export class ProcesoProductivoDetalleComponent implements OnInit {
  formulario: FormGroup;
  procesoProductivo: ProcesoProductivo;
  lisVariableIncidencia: ProcesoVariableIncidencia[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  columnas: any[];

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serProcesoProductivo: ProcesoProductivoService,
    private serVariableIncidencia: ProcesoVariableIncidenciaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.serProcesoProductivo.obtenerPorId( params[ 'id' ] ),
          this.serVariableIncidencia.obtenerPorProcesoProductivo( params[ 'id' ] ) ).subscribe( ( [ procesoProducitvo, variablesincidencia ] ) => {
          this.procesoProductivo = procesoProducitvo;
          this.lisVariableIncidencia = variablesincidencia;

          this.columnas = [
            { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: false },
            { field: 'variableIncidencia', header: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.LBL_PROSPROD' ), sort: false },
            { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
          ];

          this.carTabla = false;
          this.carInformacionInicial = false;
        } );
      } else {
        this.carTabla = false;
        this.carInformacionInicial = false;
      }
    } );

  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/proceso-productivo/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/proceso-productivo/' ] );
    }
  }


}
